<template>
  <div
    :class="[item.selected ? 'event-template-card-hover' : '', 'event-template-card']"
    @mouseup="goTemplateDetail"
    @mouseover="handleTooltip"
    v-lego-tooltip="{
      value: tooltipData,
      position: 'top',
      timer: 500,
      moreAction: 'clickToHide',
      isShowHTML: true
    }"
  >
    <!-- <div class="title">{{ item.productTypeName }}</div> -->
    <div class="desc">
      {{ item.eventTemplateName }}
    </div>

    <div class="content">
      <div class="count">{{ $t('page.template.eventCnt', [item.metricKeyCnt]) }}</div>
      <div class="gr-tag">
        <lego-chip :class="createdClass" small colorType="normal">{{ createdBy }}</lego-chip>
        <lego-chip
          v-if="item.asgYN == 'Y'"
          class="mine asg"
          :class="isDelASG ? 'bg-asg' : ''"
          small
          colorType="normal"
        >
          <div class="warning-del-asg" v-lego-tooltip="isDelASG ? t('page.template.delASG') : ''">
            <lego-icon
              class="lego-text-field__icon-wrap__icon icon-asg"
              iconType="df"
              icon="del_asg"
              :size="16"
              v-if="isDelASG"
            />
            <span class="asg-text">{{ $t('page.template.asg') }}</span>
          </div>
        </lego-chip>
      </div>
    </div>

    <div class="btn-more" @mouseup="stopClickEvent">
      <lego-drop-holder
        :items="templateMenu"
        menuDirection="right"
        :itemWidth="80"
        class="hoverActive"
        style="cursor: pointer"
        @click="clickTemplateMenu"
      >
        <lego-icon class="icon-event-template" iconType="df" icon="more" size="20px" />
      </lego-drop-holder>
    </div>

    <TooltipEventTemplate
      :id="item.eventTemplateSq"
      v-show="false"
      ref="tooltipTemplate"
      :dataTooltip="item"
    />
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import TooltipEventTemplate from './components/TooltipEventTemplate.vue';

export default {
  mixins: [i18nMixin],
  emits: ['clickTemplateMenu', 'clickTemplate'],
  props: {
    item: { type: Object }
  },
  components: { TooltipEventTemplate },
  data() {
    return {
      tooltipData: ''
    };
  },
  computed: {
    isDelASG() {
      return this.item.existsAsg == 'Y';
    },
    templateMenu() {
      return [
        { value: 'modify', text: this.t('button.edit') },
        { value: 'delete', text: this.t('button.remove') },
        { value: 'share', text: this.t('page.template.share') }
      ];
    },
    createdBy() {
      let author = this.item.createdByName;
      if (this.item.mine) {
        author = this.t('page.template.mine');
      }
      return author;
    },
    createdClass() {
      return this.item.mine ? 'mine' : 'not-mine';
    }
  },
  methods: {
    handleTooltip() {
      this.tooltipData = '';
      this.$nextTick(() => {
        if (this.$refs.tooltipTemplate) this.tooltipData = this.$refs.tooltipTemplate.$el.innerHTML;
      });
    },

    stopClickEvent(e) {
      e.stopPropagation();
    },

    clickTemplateMenu(item) {
      let templateData = this.getTemplateData();
      templateData.menu = item.value;
      this.$emit('clickTemplateMenu', templateData);
    },

    goTemplateDetail() {
      this.$emit('clickTemplate', this.getTemplateData());
    },

    getTemplateData() {
      const templateData = {};
      Object.keys(this.item).forEach((key) => {
        templateData[key] = this.item[key];
      });
      return templateData;
    }
  }
};
</script>
<style lang="scss" scoped>
.gr-tag {
  display: flex;

  .lego-chip__container.mine {
    border: none !important;
  }

  .bg-asg {
    background-color: #fff7db !important;
  }

  .asg {
    margin-left: 10px;
  }

  .warning-del-asg {
    display: flex;
    align-items: center;
    ::v-deep .icon-asg {
      margin-right: 3px;
    }

    .asg-text {
      flex: 1;
      text-align: center;
    }
  }
}
.event-template-card {
  position: relative;
  height: 252px;
  margin-bottom: 22px;
  border: 1px solid #d2d3d6;
  border-radius: 4px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 9px;
  cursor: pointer;

  &:hover {
    border: 1px solid #364fc7;

    .title,
    .desc,
    .count {
      color: var(--blue-with-a-hint-of-purple);
    }

    .mine.lego-chip__container,
    .lego-chip__container.mine,
    .not-mine.lego-chip__container,
    .lego-chip__container.not-mine {
      color: var(--blue-with-a-hint-of-purple);
      border: solid 1px #d6dcf4;
      background-color: var(--color-primary-tint-01);
    }

    .lego-drop-holder {
      display: inline-block;
    }
  }

  .content {
    margin-top: auto;
    overflow: hidden;
  }

  .desc {
    height: 84px;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.86;
    color: var(--dark);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: calc(100% - 21px);
  }

  .tooltip {
    display: none;
  }

  .tooltip:hover {
    display: inline-block;
  }

  .count {
    padding-bottom: 8px;
  }

  .btn-more {
    position: absolute;
    top: 16px;
    right: 13px;
  }

  .mine.lego-chip__container,
  .lego-chip__container.mine {
    border: solid 1px #d2d3d6;
    background-color: var(--color-ui-10);
  }

  .not-mine.lego-chip__container,
  .lego-chip__container.not-mine {
    border: solid 1px var(--color-ui-10);
    background-color: var(--color-ui-12);
    color: #959595;
  }
}

.event-template-card-hover {
  border: 1px solid #364fc7;

  .title,
  .desc,
  .count {
    color: var(--blue-with-a-hint-of-purple);
  }

  .mine.lego-chip__container,
  .lego-chip__container.mine,
  .not-mine.lego-chip__container,
  .lego-chip__container.not-mine {
    color: var(--blue-with-a-hint-of-purple);
    border: solid 1px #d6dcf4;
    background-color: var(--color-primary-tint-01);
  }

  .lego-drop-holder {
    display: inline-block;
  }
}

.modal-event-card {
  .btn-more {
    display: none;
  }
}

.icon-event-template {
  width: 32px;
  height: 32px;
  background: #ffffff;
}
</style>
